import { styled, css } from 'styled-components';

const Heading = css`
	font-weight: 800;
	letter-spacing: 0;
	color: var(--Primary-squla-dark-blue);
`;

const HeadingXL = styled.h1`
	${Heading};
	font-size: 80px;
	line-height: 88px;
`;

const HeadingL = styled.h2`
	${Heading};
	font-size: 48px;
	line-height: 48px;
`;

const HeadingM = styled.h3`
	${Heading};
	font-size: 32px;
	line-height: 40px;
`;

const HeadingS = styled.h4`
	${Heading};
	font-size: 24px;
	line-height: 32px;
`;

const HeadingXS = styled.h5`
	${Heading};
	font-size: 18px;
	line-height: 28px;
`;

const HeadingXXS = styled.h6`
	${Heading};
	font-size: 16px;
	line-height: 20px;
`;

const Subtitle = css`
	font-weight: 700;
	letter-spacing: 0;
	color: var(--Primary-squla-dark-blue);
`;

const SubtitleS = styled.p`
	${Subtitle};
	font-size: 14px;
	line-height: 16px;
`;

const SubtitleM = styled.p`
	${Subtitle};
	font-size: 16px;
	line-height: 20px;
`;

const Text = css`
	font-weight: 400;
	letter-spacing: 0;
	color: var(--Primary-squla-dark-blue);
`;

const TextL = styled.p`
	${Text};
	font-size: 18px;
	line-height: 28px;
`;

const TextM = styled.p`
	${Text};
	font-size: 16px;
	line-height: 24px;
`;

const TextS = styled.p`
	${Text};
	font-size: 14px;
	line-height: 20px;
`;

export {
	HeadingXL,
	HeadingL,
	HeadingM,
	HeadingS,
	HeadingXS,
	HeadingXXS,
	SubtitleM,
	SubtitleS,
	TextL,
	TextM,
	TextS,
};
